export const PROFESSION = 'Software Engineer'
export const INFO_TYPEWRITER_DELAY = 20
export const SCENE_STEP_DELAY = 1000
